import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PRACTICE_LIST = 'GET_PRACTICE_LIST';
export const GET_PRACTICE_LIST_SUCCESS = 'GET_PRACTICE_LIST_SUCCESS';
export const GET_PRACTICE_LIST_FAILURE = 'GET_PRACTICE_LIST_FAILURE';

// Action Creators
export const getPractice = () => ({
  type: GET_PRACTICE_LIST,
});

export const getPracticeSuccess = (users) => ({
  type: GET_PRACTICE_LIST_SUCCESS,
  payload: users,
});

export const getPracticeFailure = (error) => ({
  type: GET_PRACTICE_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getPracticeList = (external) => {
  return async (dispatch) => {
    dispatch(getPractice());
    try {
      const response = await getMethodWithToken(url.getPractice);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getPracticeSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getPracticeFailure(error?.message));
    }
  };
};
